<template>
  <el-container>
    <el-main>
      <div class="granderview_home">
        <!-- 轮播图 -->
        <div class="swiper">
          <el-carousel height="400px" :interval="5000" indicator-position="none">
            <el-carousel-item v-for="item in banner" :key="item.id">
              <a v-if="item.link" target="_blank" :href="item.link">
                <img :src="item.coverPath" alt />
              </a>
              <img :src="item.coverPath" alt v-else />
            </el-carousel-item>
          </el-carousel>
          <div class="link_nav_box">
            <ul class="link_nav m">
              <li>
                <a href="#/personal_center/homepage">
                  学生认证
                  <span class="quan">
                    <i class="el-icon-arrow-right"></i>
                  </span>
                  <img src="@/assets/img/home/it_1.png" alt="">
                </a>
              </li>
              <li>
                <a href="#/personal_center/works">
                  作品发布
                  <span class="quan">
                    <i class="el-icon-arrow-right"></i>
                  </span>
                  <img src="@/assets/img/home/it_2.png" alt="">
                </a>
              </li>
              <li>
                <a href="#/exhibitions_list">
                  专题展馆
                  <span class="quan">
                    <i class="el-icon-arrow-right"></i>
                  </span>
                  <img src="@/assets/img/home/it_3.png" alt="">
                </a>
              </li>
              <li>
                <a href="#/work_list">
                  作品欣赏
                  <span class="quan">
                    <i class="el-icon-arrow-right"></i>
                  </span>
                  <img src="@/assets/img/home/it_4.png" alt="">
                </a>
              </li>
            </ul>
          </div>
        </div>
        <!-- 2020毕设热门展览 -->
        <div class="hot_GE">
          <div class="m">
            <div class="_title">
              <h2>
                <span>毕设热门展览</span>
              </h2>
            </div>
            <div class="content">
              <div class="hot_GE_l">
                <div class="one" v-if="HotExhibitions.length > 0" @click="toDetail(HotExhibitions[0].id)">
                  <img class="img" :src="HotExhibitions[0].coverPath" alt />
                  <div class="kuai"></div>
                  <div class="arrow">
                    <i class="el-icon-arrow-right"></i>
                  </div>
                  <div class="_text">
                    <h3>{{HotExhibitions[0].name}}</h3>
                    <h4>{{HotExhibitions[0].school_name}}</h4>
                    <h5>{{HotExhibitions[0].year}}</h5>
                  </div>
                </div>
              </div>
              <div class="hot_GE_r">
                <div class="hot_GE_r_t">
                  <div class="two" v-if="HotExhibitions.length > 1" @click="toDetail(HotExhibitions[1].id)">
                    <img class="img" :src="HotExhibitions[1].coverPath" alt />
                    <div class="kuai"></div>
                    <div class="arrow">
                      <i class="el-icon-arrow-right"></i>
                    </div>
                    <div class="_text">
                      <h3>{{HotExhibitions[1].name}}</h3>
                      <h4>{{HotExhibitions[1].school_name}}</h4>
                      <h5>{{HotExhibitions[1].year}}</h5>
                    </div>
                  </div>
                  <div class="three" v-if="HotExhibitions.length > 2" @click="toDetail(HotExhibitions[2].id)">
                    <img class="img" :src="HotExhibitions[2].coverPath" alt />
                    <div class="kuai"></div>
                    <div class="arrow">
                      <i class="el-icon-arrow-right"></i>
                    </div>
                    <div class="_text">
                      <h3>{{HotExhibitions[2].name}}</h3>
                      <h4>{{HotExhibitions[2].school_name}}</h4>
                      <h5>{{HotExhibitions[2].year}}</h5>
                    </div>
                  </div>
                </div>
                <div class="hot_GE_r_b">
                  <div class="three" v-if="HotExhibitions.length > 3" @click="toDetail(HotExhibitions[3].id)">
                    <img class="img" :src="HotExhibitions[3].coverPath" alt />
                    <div class="kuai"></div>
                    <div class="arrow">
                      <i class="el-icon-arrow-right"></i>
                    </div>
                    <div class="_text">
                      <h3>{{HotExhibitions[3].name}}</h3>
                      <h4>{{HotExhibitions[3].school_name}}</h4>
                      <h5>{{HotExhibitions[3].year}}</h5>
                    </div>
                  </div>
                  <div class="two" v-if="HotExhibitions.length > 4" @click="toDetail(HotExhibitions[4].id)">
                    <img class="img" :src="HotExhibitions[4].coverPath" alt />
                    <div class="kuai"></div>
                    <div class="arrow">
                      <i class="el-icon-arrow-right"></i>
                    </div>
                    <div class="_text">
                      <h3>{{HotExhibitions[4].name}}</h3>
                      <h4>{{HotExhibitions[4].school_name}}</h4>
                      <h5>{{HotExhibitions[4].year}}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 更多按钮 -->
            <div class="more_btn">
              <el-button @click="go('exhibitions_list')">
                <div>MORE+</div>
                <div>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </el-button>
            </div>
          </div>
        </div>

        <!-- 2020毕设热门作品 -->
        <div class="hot_pro">
          <div class="m">
            <div class="_title">
              <h2>
                <span>毕设热门作品</span>
              </h2>
            </div>
            <div class="content">
              <pro_list :list="HotOpus"/>
            </div>
            <!-- 更多按钮 -->
            <div class="more_btn">
              <el-button @click="go('work_list')">
                <div>MORE+</div>
                <div>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </el-button>
            </div>
          </div>
        </div>

        <!-- 合作学校 -->
        <div class="parenter_school_box">
          <div class="m">
            <div class="parenter_school" v-if="HotSchools.length > 0">
              <div class="parenter_school_l">
                <div class="_title">{{HotSchools[activeSchool].name}}</div>
                <p>{{HotSchools[activeSchool].synopsis}}</p>
<!--                <p>学校本科教育现有艺术类、设计类、人文类和教育类等8个学院和1个思想政治理论课教学部，设有29个专业和55个专业方向。研究生教育</p>-->
                <div class="color_blue">
                  <a :href="HotSchools[activeSchool].website" target="_blank">
                    院校主页
                    <i class="el-icon-arrow-right"></i>
                  </a>
                </div>
                <!-- 更多按钮 -->
                <div class="more_btn">
                  <el-button @click="go('school_list')">
                    <div>MORE+</div>
                    <div>
                      <i class="el-icon-arrow-right"></i>
                    </div>
                  </el-button>
                </div>
              </div>
              <div class="parenter_school_r">
                <ul>
                  <li v-for="item,index in HotSchools" :class="{active:index===activeSchool}" @mouseover="schoolSelect(index)" @click="toSchoolDetail(item.id)">
                    <img :src="item.coverPath" alt />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
<!--      <question></question>-->
    </el-main>
  </el-container>
</template>

<script>
import pro_list from "@/components/list_item/pro_list/pro_list"
import question from "@/views/home/components/question.vue"
export default {
  components: {
    pro_list,
    question
  },
  data() {
    return {
      banner: [], //轮播图
      activeSchool: 0,
      HotExhibitions: [],
      HotSchools: [],
      HotOpus: []
    };
  },
  created() {
    //轮播图
    this.getBanner();
    this.getHotExhibitions();
    this.getHotOpus();
    this.getHotSchools();
  },
  methods: {
    go(name){
      this.$router.push({
        name:name
      })
    },
    //毕业展详情
    toDetail(id){
      this.$router.push({
        name:'exhibitions_detail',
        query:{
          id:id
        }
      })
    },
    toSchoolDetail(id){
      this.$router.push({
        name:'school_index',
        query:{
          id:id
        }
      })
    },
    //选中学校
    schoolSelect(index){
      this.activeSchool = index;
    },
    //查询热门展览
    getHotExhibitions(){
      let params = {
        pageSize: 5,
        is_2020: false
      }
      this.api.getHotExhibitions(params).then(res=>{
        if(res.error['err_code'] !== 0) return;
        this.HotExhibitions = res.obj.list;
      })
    },
    //查询热门作品
    getHotOpus(){
      let params = {
        pageSize: 8
      }
      this.api.getHotOpus(params).then(res=>{
        if(res.error['err_code'] !== 0) return;
        this.HotOpus = res.obj.list;
      })
    },
    //查询热门学校
    getHotSchools(){
      let params = {
        pageSize: 12
      }
      this.api.getHotSchools(params).then(res=>{
        if(res.error['err_code'] !== 0) return;
        this.HotSchools = res.obj.list;
      })
    },
    //获取轮播图
    getBanner() {
      let params = {
        type: "ExhibitionCarousel",
        class_one: "ExhibitionCarouselHome",
        pageNo: 0,
        pageSize: 10,
        sort: "SortDefault"
      };
      this.api.getNews(params).then(res => {
        if (res.error.err_code !== 0) return;
        this.banner = res.obj.list;
      });
    },
  }
};
</script>

<style lang="scss">
/*首页*/
.granderview_home {
  background-color: #f5f5f5;
  position: relative;
  // min-width: 100%;
  // 轮播图
  .more_btn {
    margin-top: 30px;
  }
  .swiper {
    background-color: #999;
    position: relative;
    .link_nav_box {
      position: absolute;
      bottom: 0;
      z-index: 11;
      width: 100%;
      background: #5F697F;
      .link_nav {
        display: flex;
        li {
          a {
            width: 299px;
            height: 90px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-left: 1px solid rgba(232,232,232,0.16);
            font-size: 18px;
            color: #fff;
            position: relative;
            .quan {
              border: 1px solid #fff;
              border-radius: 50%;
              margin-left: 9px;
            }
            img{
              display: inline-block;
              position: absolute;
              width: 86px;
              right: 0;
              top: 0;
            }
          }
          &:last-child {
            a {
              border-right: 1px solid rgba(232,232,232,0.16);
            }
          }
        }
      }
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
    .el-carousel__arrow {
      border-radius: 0;
      width: 40px;
      height: 40px;
      i:before {
        content: "";
        background: url(https://sctcc-applet.oss-cn-shenzhen.aliyuncs.com/icons/img/icon1.png)
          no-repeat;
        display: inline-block;
        width: 40px;
        height: 40px;
      }
      i.el-icon-arrow-left::before {
        background-position: -5px -286px;
      }
      i.el-icon-arrow-right::before {
        background-position: -5px -331px;
      }
    }
    .el-carousel__arrow--left {
      left: 60px;
    }
    .el-carousel__arrow--right {
      right: 60px;
    }
    .el-carousel__arrow:hover {
      opacity: 0.4;
    }
    .el-carousel__button {
      width: 24px;
      height: 3px;
      background: #c6c6c6;
    }
    .el-carousel__indicator--horizontal.is-active {
      .el-carousel__button {
        background: #111;
      }
    }
  }
  .hot_GE {
    padding: 47px 0 80px;
    background: #fff;
    .m {
      ._title {
        height: 100px;
        line-height: 100px;
        h2 {
          position: relative;
          span {
            font-weight: bold;
            font-size: 30px;
            color: #111;
            position: absolute;
            z-index: 1;
          }
        }
        h2::after {
          content: "";
          width: 30px;
          height: 30px;
          background: rgba(91, 134, 231, 0.4);
          position: absolute;
          top: 28px;
          left: -10px;
        }
      }
      .content {
        display: flex;
        .img{
          width: 100%;
          height: 100%;
          object-position: center;
          object-fit: cover;
        }
        .hot_GE_l {
          .one {
            width: 476px;
            height: 476px;
            background: red;
            position: relative;
            overflow: hidden;
            cursor: pointer;
            .kuai {
              width: 673px;
              height: 673px;
              background: #000;
              transform: rotateZ(45deg);
              position: absolute;
              left: -673px;
              top: -673px;
              z-index: 1;
              opacity: 0;
              transition: all 0.5s;
            }
            .arrow {
              font-size: 20px;
              color: #fff;
              position: absolute;
              right: -14px;
              bottom: 14px;
              opacity: 0;
              transition: all 0.5s;
            }
            ._text {
              width: 100%;
              height: 100%;
              padding: 25px 37px 0 20px;
              box-sizing: border-box;
              position: absolute;
              left: 0;
              top: -200px;
              z-index: 2;
              opacity: 0;
              transition: all 0.3s linear 0.1s;
              h3 {
                font-size: 20px;
                line-height: 35px;
                color: #fff;
              }
              h4 {
                font-size: 14px;
                line-height: 27px;
                color: #fff;
                margin-top: 8px;
              }
              h5 {
                font-size: 14px;
                line-height: 32px;
                color: #fff;
              }
            }
          }
          .one:hover {
            .kuai {
              left: -178px;
              top: -181px;
              opacity: 1;
            }
            .arrow {
              right: 14px;
              opacity: 1;
            }
            ._text {
              top: 0;
              opacity: 1;
            }
          }
        }
        .hot_GE_r {
          width: 704px;
          margin-left: 20px;
          display: flex;
          flex-direction: column;
          .hot_GE_r_t {
            display: flex;
            justify-content: space-between;
          }
          .hot_GE_r_b {
            display: flex;
            justify-content: space-between;
            margin-top: 20px;
          }
          .two {
            width: 456px;
            height: 228px;
            background: red;
            position: relative;
            overflow: hidden;
            cursor: pointer;
            .kuai {
              width: 600px;
              height: 600px;
              background: #000;
              transform: rotateZ(45deg);
              position: absolute;
              left: -600px;
              top: -600px;
              z-index: 1;
              opacity: 0;
              transition: all 0.5s;
            }
            .arrow {
              font-size: 20px;
              color: #fff;
              position: absolute;
              right: -14px;
              bottom: 14px;
              opacity: 0;
              transition: all 0.5s;
            }
            ._text {
              width: 100%;
              height: 100%;
              padding: 25px 35px 0 20px;
              box-sizing: border-box;
              position: absolute;
              left: 0;
              top: -200px;
              z-index: 2;
              opacity: 0;
              transition: all 0.3s linear 0.1s;
              h3 {
                font-size: 20px;
                line-height: 35px;
                color: #fff;
              }
              h4 {
                font-size: 14px;
                line-height: 27px;
                color: #fff;
                margin-top: 8px;
              }
              h5 {
                font-size: 14px;
                line-height: 32px;
                color: #fff;
              }
            }
          }
          .two:hover {
            .kuai {
              left: -190px;
              top: -262px;
              opacity: 1;
            }
            .arrow {
              right: 14px;
              opacity: 1;
            }
            ._text {
              top: 0;
              opacity: 1;
            }
          }
          .three {
            width: 228px;
            height: 228px;
            background: red;
            position: relative;
            overflow: hidden;
            cursor: pointer;
            .kuai {
              width: 322px;
              height: 322px;
              background: #000;
              transform: rotateZ(45deg);
              position: absolute;
              left: -322px;
              top: -322px;
              z-index: 1;
              opacity: 0;
              transition: all 0.5s;
            }
            .arrow {
              font-size: 20px;
              color: #fff;
              position: absolute;
              right: -14px;
              bottom: 14px;
              opacity: 0;
              transition: all 0.5s;
            }
            ._text {
              width: 100%;
              height: 100%;
              padding: 25px 30px 0 20px;
              box-sizing: border-box;
              position: absolute;
              left: 0;
              top: -200px;
              z-index: 2;
              opacity: 0;
              transition: all 0.3s linear 0.1s;
              h3 {
                font-size: 16px;
                line-height: 24px;
                color: #fff;
              }
              h4 {
                font-size: 14px;
                line-height: 27px;
                color: #fff;
                margin-top: 8px;
              }
              h5 {
                font-size: 14px;
                line-height: 32px;
                color: #fff;
              }
            }
          }
          .three:hover {
            .kuai {
              left: -94px;
              top: -95px;
              opacity: 1;
            }
            .arrow {
              right: 14px;
              opacity: 1;
            }
            ._text {
              top: 0;
              opacity: 1;
            }
          }
        }
      }
    }
  }
  .hot_pro {
    padding: 47px 0 80px;
    background: #f5f5f5;
    .m {
      ._title {
        height: 100px;
        line-height: 100px;
        h2 {
          position: relative;
          span {
            font-weight: bold;
            font-size: 30px;
            color: #111;
            position: absolute;
            z-index: 1;
          }
        }
        h2::after {
          content: "";
          width: 30px;
          height: 30px;
          background: rgba(91, 134, 231, 0.4);
          position: absolute;
          top: 28px;
          left: -10px;
        }
      }
      .content {

      }
    }
  }
  .parenter_school_box {
    background-color: #fff;
    height: 620px;
    padding-top: 67px;
    box-sizing: border-box;
    background-image: url("~@/assets/img/home/school_bg.png");
    .m {
      .parenter_school {
        display: flex;
        justify-content: space-between;
        .parenter_school_l {
          ._title {
            height: 96px;
            line-height: 96px;
            color: #111;
            font-size: 30px;
            font-weight: bold;
          }
          p {
            font-size: 14px;
            color: #666;
            line-height: 24px;
            width: 506px;
            margin-bottom: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
          }
          .color_blue{
            a{
              color: #4192FF;
            }
          }
          .more_btn {
            margin-top: 80px;
          }
        }
        .parenter_school_r {
          ul {
            display:flex;
            flex-wrap: wrap;
            width: 595px;
            li {
              width: 185px;
              height: 100px;
              background: #ffffff;
              margin: 0 20px 20px 0;
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              box-shadow:0px 0px 20px 0px rgba(187,193,203,0.2);
              img{
                height: 100%;
              }
            }
            li:hover{
              box-shadow:0px 0px 20px 0px rgba(187,193,203,0.5);
            }
            li.active {
              box-shadow:0px 0px 20px 0px rgba(187,193,203,0.5);
            }
            li:nth-of-type(3n) {
              margin-right: 0;
            }
          }
        }
      }
    }
  }
  // 流程说明内容
  .process_description {
    width: 100%;
    height: 340px;
    background: url(../../assets/img/home/lc_bg.png) no-repeat;
    background-size: 100% 340px;
    background-position: center;
    margin-bottom: 37px;
    h2 {
      font-size: 30px;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      text-align: center;
      line-height: 150px;
    }
    img {
      width: 1200px;
      display: block;
      margin: 0 auto;
    }
  }
  // 内容
  .granderview_content {
    padding-bottom: 100px;
    background-color: #fff;
    // 设计任务
    .design_task_box {
      width: 100%;
      background-color: #f5f5f5;
      padding-bottom: 60px;
      padding-top: 40px;

      .design_task {
        margin-bottom: 60px;
        background-color: #f5f5f5;
        // 标题
        h3.design_h3 {
          font-size: 34px;
          color: $font-black;
          line-height: 114px;
          padding-top: 40px;
        }
        // 列表信息
        .designList_box {
          margin-bottom: 10px;
          width: 100%;
          ul {
            display: flex;
            flex-wrap: wrap;
          }
        }
        // 按钮
      }
    }
    // 入驻设计师
    .resident_designer {
      margin-bottom: 60px;
      .resident_designer_box {
        overflow: hidden;
        display: flex;
        width: 1200px;
        flex-wrap: wrap;
        position: relative;
        margin-bottom: 10px;
        .resident_designer_item {
          width: 285px;
          height: 285px;
          background-color: #ccc;
          margin-bottom: 20px;
          cursor: pointer;
          position: relative;
          margin-right: 20px;
          .img {
            width: 100%;
            height: 100%;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
              transition: all 0.3s;
            }
          }

          .close {
            position: absolute;
            top: 0;
            left: 0;
            width: 70px;
            height: 70px;
            background-color: #111;
            display: flex;
            align-items: center;
            justify-content: center;
            i {
              font-size: 28px;
              color: #fff;
            }
            z-index: 999;
          }
          .close_right {
            left: auto;
            right: 0;
          }
          .extr_info {
            width: 590px;
            height: 590px;
            position: absolute;
            background-color: #222;
            right: -610px;
            visibility: hidden;
            z-index: 101;
            top: 0;
            transition: opacity 0.4s;
            opacity: 0;
            cursor: auto;
            box-sizing: border-box;
            padding: 100px 56px 0;
            color: #fff;
            h1 {
              font-size: 30px;
              // font-weight: 600;
              line-height: 50px;
            }
            .designation {
              font-size: 18px;
              color: #999;
              line-height: 38px;
              min-height: 27px;
            }
            .hor_line {
              display: block;
              width: 38px;
              height: 3px;
              background-color: #fff;
              margin: 20px 0 50px;
            }
            .intro {
              line-height: 27px;
              font-size: 16px;
              min-height: 27px;
            }
          }
          .extr_info_show {
            opacity: 1;
            visibility: visible;
          }
          .extr_info_bot {
            top: auto;
            bottom: 0;
          }
          .extr_info_left {
            left: -610px;
          }
          .extr_info_left_show {
            left: -610px;
          }
          .more_icon {
            position: absolute;
            right: -20px;
            bottom: 20px;
            font-size: 18px;
            color: #fff;
            transition: all 0.3s;
          }
          .more_icon_right {
            right: 20px;
          }
        }
        .resident_designer_item:nth-child(4n) {
          margin-right: 0;
        }
        .resident_designer_item:hover {
          .more_icon {
            right: 20px;
          }
          .img img {
            transform: scale(1.1);
          }
        }
        .resident_designer_item_show {
          z-index: 101;
        }
        .mask {
          position: absolute;
          left: 0px;
          top: 0px;
          width: 1200px;
          height: 590px;
          background: rgba($color: #ffffff, $alpha: 0);
          z-index: -1;
          transition: all 0.4s;
        }
        .mask_show {
          background: rgba($color: #ffffff, $alpha: 0.7);
          z-index: 100;
        }
      }
    }
    // 成功案例
    .successful_case {
      // margin-bottom: 60px;
      .successful_case_box {
        margin-bottom: 15px;
        ul {
          display: flex;
          flex-wrap: wrap;
          // justify-content: space-between;
        }
      }
    }
  }
}
</style>
